import { useEffect, useState } from "react";

export const useSignIn = ({
  provider,
  redirectUri,
  additionalState = {}
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('')

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authError = urlParams.get('auth_error');

    if (authError) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('auth_error');

      window.history.replaceState({}, document.title, newUrl.toString());
    }
  }, []);

  const signIn = async () => {
    setIsLoading(true);

    const { success, error } = await provider(redirectUri, additionalState);

    if (!success) {
      setIsLoading(false);
      setError(error?.detail || error?.message || error || "An unknown error occurred.");
    }

    return success
  };

  return {
    isLoading,
    signIn,
    error
  }
}
